import React, { useState } from 'react';
import styled from 'styled-components';

import { FilterTabs, FilterTab, FiltersWrap } from '../../../../components/Inputs/styles';
import ContentBoardStyled from '../../../../components/ContentBoardStyled';
import LotlenzStatuses from './LotlenzStatuses';
import VehicleInfoBox from './VehicleInfoBox';
import VehicleComment from './VehicleComment';
import VehicleProvider from './context';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role='tabpanel' hidden={value !== index} {...other}>
      {value === index && <FiltersWrap p={3}>{children}</FiltersWrap>}
    </div>
  );
}

const InfoBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 340px;
  padding: 12px 20px 4px;
`;

const LABELS = {
  make: 'Make',
  model: 'Model',
  year: 'Year',
  stock: 'Stock',
  vin: 'VIN',
  color: 'Color',
  type: 'Type',
  imageCount: 'Photo Count (HomeNet CSV)',
  uploadedImageCount: 'Photo Count (lotflo.net app)',
  daysInStock: 'Days in stock',
  lastImageUploadedOn: 'Photo updated',
  imageType: 'Source location'
};

const VehicleInfoBoard = ({ vehicle, mutateVehicle }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <VehicleProvider vehicle={vehicle} mutateVehicle={mutateVehicle}>
      <ContentBoardStyled css={{ minHeight: '130px', marginLeft: 0, marginTop: 0, width: '482px' }}>
        <FilterTabs value={tabIndex} onChange={(e, value) => setTabIndex(value)}>
          <FilterTab label='VEHICLE INFORMATION' />
          <FilterTab label='LOTLENZ VERIFICATION' />
        </FilterTabs>
        <TabPanel value={tabIndex} index={0}>
          <InfoBlock>
            {vehicle &&
              Object.keys(LABELS).map((key) => (
                <VehicleInfoBox label={LABELS[key]} labelKey={key} data={vehicle[key]} key={key} />
              ))}
          </InfoBlock>
          {Boolean(vehicle?.comment) && (
            <VehicleComment
              {...vehicle.comment}
              vin={vehicle.vin}
              hmsId={vehicle.dealership.hmsId}
              mutateVehicle={mutateVehicle}
            />
          )}
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <LotlenzStatuses />
        </TabPanel>
      </ContentBoardStyled>
    </VehicleProvider>
  );
};

export default VehicleInfoBoard;
